/* eslint-disable no-param-reassign */
import m from 'mithril';
import input from '../../components/input';
import multiSelect from '../../components/bootstrap-select';
import { runMutation } from '../../utils/fetchData';
import modalCloseButton from '../../components/modalCloseButton';

const modal = {
  key: 'ADD_PROJECT_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
    state.selectedTeams = [];
    state.showUploadResults = async () => {
      state.name = state.uploadedData.name;

      m.redraw();

      const pagesNumber = state.uploadedData.pages.length;
      const groupsNumber = state.uploadedData.pages.map(x => x.groups.length)
        .reduce((a, b) => a + b, 0);
      const questionsNumber = state.uploadedData
        .pages.map(x => x.groups
          .map(g => g.questions.length)
          .reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0);

      Object.assign(state, {
        pagesNumber,
        groupsNumber,
        questionsNumber,
      });

      m.redraw();
    };
  },
  view({ state, attrs }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'Create a Project'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m(input, {
                      label: 'Name of the project',
                      value: state.name,
                      oninput(v) {
                        state.name = v;
                      },
                    }),
                    m('.col-sm-12.col-md-12.col-lg-12',
                      attrs.teams.length === 0
                        ? []
                        : m('.form-group',
                          [
                            m('label',
                              'Teams with access'),
                            m(multiSelect, {
                              options: attrs.teams.map(({ id: value, name: label }) => ({
                                label,
                                value,
                                selected: state.selectedTeams.indexOf(value) !== -1,
                              })),
                              onChange(selectedValues) {
                                state.selectedTeams.map(async (selected) => {
                                  if (selectedValues.indexOf(selected) !== -1) { return; }

                                  state.selectedTeams = state.selectedTeams.filter(team => team !== selected);
                                  m.redraw();

                                  // await runMutation(`mutation ($team: String,$project:String) {
                                  //                     teamMutations {
                                  //                       removeProject(team: $team,project: $project)
                                  //                     }
                                  //                   }`, JSON.stringify({
                                  //   team: selected,
                                  //   project: state.project_id,
                                  // }));
                                });

                                selectedValues.map(async (selectedV) => {
                                  if (state.selectedTeams.indexOf(selectedV) !== -1) { return; }

                                  state.selectedTeams.push(selectedV);

                                  // m.redraw();
                                  // await runMutation(`mutation ($team: String,$project:String) {
                                  //                     teamMutations {
                                  //                       addProject(team: $team,project: $project)
                                  //                     }
                                  //                   }`, JSON.stringify({
                                  //   team: selectedV,
                                  //   project: state.project_id,
                                  // }));
                                  m.redraw();
                                });
                              },
                            }),
                            m('span.form-text.text-muted',
                              'Please select the teams that have access to this project'),
                          ])),
                    // m('.col-sm-12.col-md-12.col-lg-12', [
                    //   [
                    //     m('style', '#myFileInput {display:none}'),
                    //     m("input[type='file'][id='myFileInput']", {
                    //       onchange(event) {
                    //         const uploadedFile = event.target.files[0];

                    //         // if (uploadedFile.type !== "text/javascript" && uploadedFile.type !== "application/x-javascript") {
                    //         //   alert("Wrong file type == " + uploadedFile.type);
                    //         //   return false;
                    //         // }

                    //         if (uploadedFile) {
                    //           // eslint-disable-next-line no-undef
                    //           const readFile = new FileReader();
                    //           readFile.onload = function load(e) {
                    //             const contents = e.target.result;
                    //             const json = JSON.parse(contents);
                    //             state.uploadedData = json.items;
                    //             state.showUploadResults();
                    //           };
                    //           readFile.readAsText(uploadedFile);
                    //         }
                    //       },
                    //     }),
                    //   ],
                    //   m("button.btn.btn-sm.btn-brand.btn-elevate.btn-elevate-air[type='button']", {
                    //     // eslint-disable-next-line no-undef
                    //     onclick: () => document.getElementById('myFileInput').click(),
                    //   },
                    //   m('i.fa.fa-upload'),
                    //   'Upload from file'),

                    //   m('br'),
                    //   m('br'),
                    //   m('br'),

                    //   !state.questionsNumber
                    //     ? []
                    //     : m('p', `Found ${state.questionsNumber} questions in ${state.groupsNumber} groups in ${state.pagesNumber} pages`),
                    // ]),
                  ]),

                m('.modal-footer',
                  [
                    m('button.btn.btn-secondary[type="button]', {
                      onclick() {
                        modal.hide();
                      },
                    }, 'Close'),
                    m(`button.btn.btn-primary${state.loading === true ? '.k-spinner.k-spinner--v2.k-spinner--right.k-spinner--lg.k-spinner--success' : ''}`, {
                      async onclick() {
                        state.loading = true;

                        m.redraw();

                        if (!state.uploadedData) {
                          await attrs.add({
                            name: state.name,
                          }, attrs.teams.filter(team => state.selectedTeams.includes(team.id)));
                        } else {
                          await attrs.bulkAdd(state.uploadedData);
                        }

                        state.name = '';
                        state.uploadedData = undefined;

                        state.loading = false;

                        m.redraw();
                        modal.hide();
                      },
                    },
                    'Save'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
